import { message } from 'antd';

import axios from "core/lib/axios";

import Methods from "constants/methods.constants";
import ApiUrls from "constants/api.constants";

import { isResponseSuccess } from "utils/request";

import {
    SET_FINANCIAL_MANAGERS_ACTION_BEFORE,
    SET_FINANCIAL_MANAGERS_ACTION_FINISH,
    SET_FINANCIAL_MANAGERS_SAVE_ACTION_BEFORE,
    SET_FINANCIAL_MANAGERS_SAVE_ACTION_FINISH
} from "../../../../actionTypes";

import { getFinancialManagerGeneralInfo } from './general.action';

export const setFinancialManagersActionBefore = () => ({
    type: SET_FINANCIAL_MANAGERS_ACTION_BEFORE,
});

export const setFinancialManagersActionFinished = () => ({
    type: SET_FINANCIAL_MANAGERS_ACTION_FINISH,
});

export const setFinancialManagersSaveActionBefore = () => ({
    type: SET_FINANCIAL_MANAGERS_SAVE_ACTION_BEFORE,
});

export const setFinancialManagersSaveActionFinished = () => ({
    type: SET_FINANCIAL_MANAGERS_SAVE_ACTION_FINISH,
});

export const changeFinancialManagerState = d => {
    return dispatch => {
        dispatch(setFinancialManagersSaveActionBefore());
        return axios({
            url: ApiUrls.CHANGE_ACCOUNT_STATE,
            method: Methods.POST,
            data: d
        })
        .then(({ data }) => {
            if (isResponseSuccess(data)) {
                message.success(data.message);
                dispatch(getFinancialManagerGeneralInfo(d.id));
            } 
            dispatch(setFinancialManagersSaveActionFinished());
        })
        .catch((ex) => {
            dispatch(setFinancialManagersSaveActionFinished());
        })
    }
}

export const unlockFinancialManager = id => {
    return dispatch => {
        dispatch(setFinancialManagersSaveActionBefore());
        return axios({
            url: ApiUrls.UNLOCK_ACCOUNT,
            method: Methods.POST,
            data: { 
                id
            }
        })
        .then(({ data }) => {
            if (isResponseSuccess(data)){
                message.success(data.message);
                dispatch(getFinancialManagerGeneralInfo(id));
            }
            dispatch(setFinancialManagersSaveActionFinished());
        })
        .catch((ex) => {
            dispatch(setFinancialManagersSaveActionFinished());
        })
    }
}